import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import TopicComponent from '../components/topic.component';
import { selectLMSTopicsListItems, selectLMSTopicsQueryItems } from '../../../../../../redux/lms/topics/selector';
import { lmsTopics } from '../../../../../../redux/lms/topics/action';
import { settings } from '../../../../../../redux/settings/actions';
import { selectListItems } from '../../../../../../redux/library/selector';
import { lmsModules } from '../../../../../../redux/lms/modules/action';
import { selectLMSModulesListItems } from '../../../../../../redux/lms/modules/selector';
import { lmsChapters } from '../../../../../../redux/lms/collections/chapters/action';
import { selectLMSChaptersListItems } from '../../../../../../redux/lms/collections/chapters/selector';

const ManagementLMSTopic = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const lmsTopicsQuery = useSelector(selectLMSTopicsQueryItems)
  const [mediaFiles,setMediaFiles] = useState<any>([])
  const lmsTopicsItems = useSelector(selectLMSTopicsListItems)
  const lmsModulesItems = useSelector(selectLMSModulesListItems)
  const lmsChaptersItems = useSelector(selectLMSChaptersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
   const libraryData = useSelector(selectListItems)
  const [selectedTopics, setSelectLMSTopics] = useState<any>();


  const fetchLMSTopicsQueryById = () => {
    dispatch(lmsTopics.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/topics/fetch-detail`,
      entity: 'lmsTopics',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSTopics({ ...selectedTopics, [field]: event })
  }

   // media handle form change
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }

  useEffect(() => {
    dispatch(lmsModules.list({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/modules/fetch`,
      entity: 'lmsModules',
      jsonData: {}
    })).then(() => {
      dispatch(lmsChapters.list({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/chapters/fetch`,
        entity: 'lmsChapters',
        jsonData: {}
      }))
    }).then(() => {
      if (parmas?.id > 0) {
        fetchLMSTopicsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )
  useEffect(() => {
    if (isQuery) {
      setSelectLMSTopics(lmsTopicsQuery?.result?.items)
    }
  }, [isQuery]
  )
console.log(selectedTopics?.EntityId,"selectedTopics?.EntityId")
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
     mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const selectedTopicsData =
    {
       "Id" : selectedTopics?.TopicId|| 0,
      "title": selectedTopics?.Title || '',
      "description": selectedTopics?.Description || '',
      "ShortDescription": selectedTopics?.ShortDescription || '',
      "EntityTypeName": selectedTopics?.EntityTypeName || '',
      "EntityId": selectedTopics?.EntityId || '',
      "EntityName": selectedTopics?.EntityName || '',
      "parentId": selectedTopics?.ParentId || '',
      "ResourceType": selectedTopics?.ResourceType || '',
      "ResourceUrl": selectedTopics?.ResourceUrl || '',
      "Duration": selectedTopics?.Duration || '',
      "mappedTopics": {
        "mappedTopicIds": []
      },
     "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": []
      }
    }
    if (parmas?.id > 0) {
      await dispatch(lmsTopics.resetAction({ actionType: 'update' }))
      await dispatch(lmsTopics.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/topics`,
        entity: 'lmsTopics',
        jsonData: {
          Context: {},
          Records: [
            selectedTopicsData
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(lmsTopics.resetAction({ actionType: 'create' }))
      await dispatch(lmsTopics.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/topics`,
        entity: 'lmsTopics',
        jsonData: {
          Context: {},
          Records: [
            selectedTopicsData
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/lms/topics')
  }


  return (
    <>
    
      {lmsTopicsQuery?.isLoading ? <PageLoader /> :
        <TopicComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedTopics={selectedTopics}
          back={back}
          handleFormSubmit={handleFormSubmit}
          parentTopicsList={lmsTopicsItems?.result?.items}
          EntityType={libraryData?.result?.TopicEntityType}
           FileType={libraryData?.result?.FileType}
          Moduleslist={lmsModulesItems?.result?.items}
          Chapterslist={lmsChaptersItems?.result?.items}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
        />
      }
    </>
  )
}

export default ManagementLMSTopic;